import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { UPDATE_DATA_BY_MINUTE, UPDATING_DELAY_BY_SECOND } from '../../consts/consts';
import { getSubdivisonsInfo, refreshData } from '../../features/implementers/ImplemetnersSlice';
import { setLoading, stopList } from '../../features/ui/uiSlice';
import Main from '../content/main';
import MainMobile from '../content/mobile/MainMobile';
import Header from '../header/header';
import Progress from '../progressbar/Progress';
import Updating from '../updating/Updating';

const Dashboard = ({ implementers }) => {

    const isMobile = window.innerWidth < 900

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { noData, subdivisionsList } = useSelector((state) => state.implementers);
    const { next, isLoading } = useSelector((state) => state.ui);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [goScroll, setGoScroll] = useState(false)
    const [slidesToShow, setSlidesToShow] = useState(10);

    const currentImplementers = implementers ? implementers[currentIndex] : [];

    useEffect(() => {
        const updateSlidesToShow = () => {
            if (!isMobile) {
                // Вычисляем сколько элементов 69px поместится в экран.
                // Отнимаем высоту хедера (~93px), прогрессбара (10px), ApplicationRow (~40px) и отступы (~40px) = ~183px
                const availableHeight = window.innerHeight - 185;
                const count = Math.floor(availableHeight / 69);
                setSlidesToShow(count > 0 ? count : 1);
            }
        };
        updateSlidesToShow();
        window.addEventListener('resize', updateSlidesToShow);
        return () => window.removeEventListener('resize', updateSlidesToShow);
    }, [isMobile]);

    const calculatePages = (list) => {
        if (!list || isMobile) return 0;
        const pages = Math.ceil(list.length / slidesToShow) - 1;
        return pages > 0 ? pages : 0;
    };

    const [countScrolling, setCountScrolling] = useState(0);

    const scroll = () => {
        setGoScroll(true)
        setCountScrolling(countScrolling - 1)
    }
    const cancleScroll = () => setGoScroll(false)

    const nextDepartment = () => {
        if (implementers.length - 1 === currentIndex) {
            dispatch(refreshData());
            setCurrentIndex(0);
        } else setCurrentIndex(currentIndex + 1);
    };

    const previousDepartment = () => {
        if (currentIndex === 0) setCurrentIndex(implementers.length - 1);
        else setCurrentIndex(currentIndex - 1);
    }

    useEffect(() => {
        setInterval(() => {
            dispatch(getSubdivisonsInfo({ update: true, navigate }));
        }, UPDATE_DATA_BY_MINUTE * 60000);
    }, []);

    useEffect(() => {
        if (!implementers?.length) dispatch(getSubdivisonsInfo({ list_uuids: subdivisionsList, navigate }));
        else setTimeout(() => dispatch(setLoading(false)), UPDATING_DELAY_BY_SECOND * 1000);
    }, [implementers]);

    useEffect(() => {
        if (next && !isLoading) {
            if (countScrolling > 0) scroll()
            else nextDepartment()
            dispatch(stopList());
        }
    }, [next]);

    useEffect(() => {
        setCountScrolling(calculatePages(currentImplementers?.list))
    }, [currentImplementers, slidesToShow])

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
            <Header isMobile={isMobile} implementers={implementers} />
            {
                !isMobile ? isLoading ? <Updating noData={noData} /> : implementers.length ? <Progress nextDepartment={nextDepartment} previousDepartment={previousDepartment} /> : null : null
            }

            {
                !isMobile ?
                    <Main
                        implementers={implementers[currentIndex]?.list}
                        subdivision={implementers[currentIndex]?.subdivision}
                        goScroll={goScroll}
                        cancleScroll={cancleScroll}
                        isMobile={isMobile}
                        slidesToShow={slidesToShow}
                    /> :
                    <MainMobile choicedSubdivisions={implementers} />
            }

        </div>
    )
}

export default Dashboard